;(function () {
	const SECTION_SELECTOR =
		'.gallery-carousel[id^="shopify-section-"]'

	const initCarousel = () => {
		$(SECTION_SELECTOR).each(function () {
			const $section = $(this)

			if ($section.hasClass('gallery-carousel_started')) {
				return
			}

			const $box = $section
				.children('.gallery-carousel')
				.first()

			const swiperElement = $section
				.find('.gallery-carousel__swiper')
				.get(0)

			if (!$box.length || !swiperElement) {
				return
			}

			$section.addClass('gallery-carousel_started')

			const speedValue = Number($box.data('speed'))
			const speed = (speedValue || 6) * 1000

			const pauseOnHover =
				String(
					$box.attr(
						'data-gallery-carousel-hover-pause'
					)
				) === 'true'

			const swiper = new Swiper(swiperElement, {
				loop: true,
				speed: speed,
				allowTouchMove: false,
				longSwipesRatio: 0.1,
				spaceBetween: 8,
				slidesPerView: 1.5,

				/*
				 * Swiper가 슬라이드 내부 링크 클릭을
				 * 강제로 차단하지 않도록 설정합니다.
				 */
				preventClicks: false,
				preventClicksPropagation: false,
				touchStartPreventDefault: false,

				autoplay: {
					delay: 0,
					disableOnInteraction: true,
				},

				breakpoints: {
					750: {
						slidesPerView: 2.68,
						spaceBetween: 16,
					},
				},
			})

			let duration = 0
			let startTimer = null
			let linkResumeTimer = null
			let isPlaying = true
			let clickable = true

			const clearStartTimer = () => {
				if (!startTimer) return

				clearTimeout(startTimer)
				startTimer = null
			}

			const stopAutoplay = () => {
				if (
					!swiper ||
					swiper.destroyed ||
					!swiper.slides ||
					swiper.slides.length === 0
				) {
					return
				}

				clearStartTimer()

				const currentTranslate =
					swiper.getTranslate()

				const currentSlide =
					swiper.slides[swiper.activeIndex] ||
					swiper.slides[0]

				const slideWidth =
					currentSlide.offsetWidth ||
					swiper.width ||
					1

				const spaceBetween =
					Number(swiper.params.spaceBetween) || 0

				const step = slideWidth + spaceBetween

				let targetTranslate =
					-(swiper.activeIndex * step)

				if (
					swiper.slidesGrid &&
					typeof swiper.slidesGrid[
						swiper.activeIndex
					] === 'number'
				) {
					targetTranslate =
						-swiper.slidesGrid[
							swiper.activeIndex
						]
				}

				const remainingDistance = Math.abs(
					targetTranslate - currentTranslate
				)

				const distanceRatio =
					step > 0
						? Math.min(
								1,
								remainingDistance / step
							)
						: 0

				duration =
					swiper.params.speed * distanceRatio

				swiper.setTransition(0)
				swiper.setTranslate(currentTranslate)
				swiper.autoplay.stop()
			}

			const startAutoplay = (
				delay = duration
			) => {
				clearStartTimer()

				startTimer = setTimeout(() => {
					if (
						swiper.destroyed ||
						!swiper.autoplay
					) {
						return
					}

					swiper.autoplay.start()
					startTimer = null
				}, Math.max(0, delay || 0))
			}

			const resumeAutoplay = () => {
				if (
					!isPlaying ||
					swiper.destroyed
				) {
					return
				}

				swiper.slideTo(
					swiper.activeIndex,
					duration,
					false
				)

				startAutoplay(duration)
			}

			/*
			 * 재생 및 정지 버튼
			 * 현재 섹션 내부 버튼만 제어합니다.
			 */
			const toggleEl = $section
				.find('.gallery-carousel_stop')
				.get(0)

			const handleTogglePlay = () => {
				if (
					!toggleEl ||
					!swiper.slides ||
					swiper.slides.length === 0 ||
					!clickable
				) {
					return
				}

				clickable = false

				if (isPlaying) {
					stopAutoplay()
					isPlaying = false
				} else {
					isPlaying = true
					resumeAutoplay()
				}

				toggleEl.classList.toggle(
					'gallery-carousel_stop_active',
					!isPlaying
				)

				setTimeout(() => {
					clickable = true
				}, 200)
			}

			if (toggleEl) {
				toggleEl.addEventListener(
					'click',
					handleTogglePlay
				)
			}

			/*
			 * 계속 움직이는 슬라이드를 누르면
			 * 클릭 완료 전 링크가 이동할 수 있으므로,
			 * 누르는 순간 잠시 고정합니다.
			 */
			const $slideLinks = $section.find(
				'.gallery-carousel__slide_link'
			)

			$slideLinks.on(
				'pointerdown.galleryCarousel',
				function (event) {
					if (
						event.pointerType === 'mouse' &&
						event.button !== 0
					) {
						return
					}

					if (!isPlaying) return

					clearTimeout(linkResumeTimer)
					stopAutoplay()
				}
			)

			$slideLinks.on(
				'click.galleryCarousel',
				function (event) {
					/*
					 * 기본 링크 이동은 그대로 유지하고
					 * Swiper로만 클릭이 전달되지 않게 합니다.
					 */
					event.stopPropagation()
				}
			)

			$slideLinks.on(
				'pointerup.galleryCarousel pointercancel.galleryCarousel',
				function () {
					if (!isPlaying) return

					clearTimeout(linkResumeTimer)

					const desktopHoverPause =
						pauseOnHover &&
						window.matchMedia(
							'(min-width: 750px) and (hover: hover) and (pointer: fine)'
						).matches &&
						swiperElement.matches(':hover')

					/*
					 * 호버 정지 상태라면 기존 호버 로직이
					 * mouseleave에서 재생을 다시 시작합니다.
					 */
					if (desktopHoverPause) {
						return
					}

					/*
					 * pointerup 직후 발생하는 click이
					 * 완료될 때까지 슬라이드를 고정합니다.
					 */
					linkResumeTimer = setTimeout(() => {
						resumeAutoplay()
					}, 150)
				}
			)
		})
	}

	const handleReady = () => {
		initCarousel()

		document.addEventListener(
			'shopify:section:load',
			function () {
				initCarousel()
			}
		)
	}

	if (document.readyState === 'loading') {
		document.addEventListener(
			'DOMContentLoaded',
			handleReady
		)
	} else {
		handleReady()
	}
})()